
import {
    IonButton, IonButtons, IonItem, IonLabel, IonList, IonToolbar
} from "@ionic/react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { searchSnapshots } from "../../misc/phqHTTP";
import { QuestionnaireModel, SnapShot } from "../../models/questionnaire.model";
import Moment from 'react-moment';
import { AppContext } from "../../context/app.context";
import { QuestionnaireActionTypes } from "../../reducers/questionnaire.reducer";
import PHQRestoreAlert from "./PHQRestoreAlert";


const PHQSnapShotList = (props: { fnCloseModal: (result: boolean) => void }) => {

    const appContext = useContext(AppContext);
    const {questionnaire, updateQuestionnaire, notifySuccess} = appContext;
    const [alertOpen, setAlertOpen] = useState(false);
    const [snapShopList, setIsSnapShotList] = useState<SnapShot[]>();
    const currentSnapShotID = questionnaire.SnapShotID;

    const getTopSnapShotCallBack = useCallback(async () => {
        const publishedVer = (questionnaire.PhqSelected.Versions || []).find(v => v.IsCurrent);
        const res = await searchSnapshots({phqVersionId: publishedVer?.PHQVersionID, count: 10});
        const snapshots = res.data.result;
        setIsSnapShotList(snapshots);
    }, [questionnaire.PhqSelected.Versions])

    const setPreviewSnapShot = useCallback((snapshot: SnapShot) => {
        const preVersion = JSON.parse(snapshot.RawPHQ) as QuestionnaireModel;
        preVersion.Versions = questionnaire.PhqSelected.Versions;
        const currentPHQ = questionnaire.ViewMode ? JSON.parse(questionnaire.CurrentPHQ) : questionnaire?.PhqSelected
        const payload = {
            PhqSelected: preVersion,
            ViewMode: true,
            IsSnapShot: true,
            SnapshotID: snapshot.SnapshotID,
            VersionID: snapshot.PHQVersionID,
            CurrentPHQ: JSON.stringify(currentPHQ)
        }
        updateQuestionnaire(QuestionnaireActionTypes.UPDATE_VIEW_MODE, payload);
        props.fnCloseModal(true);
        notifySuccess('View Mode Active');

    }, [questionnaire, updateQuestionnaire, notifySuccess, props])

    useEffect(() => {
        getTopSnapShotCallBack();
    }, [getTopSnapShotCallBack])

    return (
        <React.Fragment>
            <IonList>
                {snapShopList?.map((snapShot, index) => {
                    return (
                        <IonItem key={index}>
                            <IonToolbar>
                                <p><strong>Action:</strong> {snapShot.Action}</p>
                                <IonLabel>
                                    <p><strong>Created on :</strong>  <Moment format="YYYY/MM/DD hh:mm" date={snapShot.CreatedOn} /></p>
                                </IonLabel>
                                <IonButtons slot="end">
                                    <IonButton size="small" fill="outline" onClick={() => { setAlertOpen(true) }}>
                                        Restore
                                    </IonButton>
                                    <PHQRestoreAlert version={undefined} snapShot={snapShot} isOpen={alertOpen} fnCloseModal={() => { setAlertOpen(false); props.fnCloseModal(true); }} />
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton size="small" fill="outline" color={currentSnapShotID === snapShot.SnapshotID ? 'success' : ''} onClick={() => { setPreviewSnapShot(snapShot); }}>
                                        View
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonItem>
                    )
                })}
            </IonList>
        </React.Fragment>

    )
}

export default PHQSnapShotList;
